module.exports = __webpack_public_path__ + "static/images/containers/EloLeaderboard/images/tab-border_disabled.6685b021.png";


//////////////////
// WEBPACK FOOTER
// ./containers/EloLeaderboard/images/tab-border_disabled.png
// module id = 3105
// module chunks = 11